var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_c('progress-bar', {
    attrs: {
      "percent": 50
    }
  }), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("What is connected to:")]), _c('BlackISVG', {
    staticClass: "info-icon",
    on: {
      "click": function ($event) {
        _vm.noteVisible = true;
      }
    }
  }), _vm.$store.getters.is2P ? _c('UnitInputGroup2P', {
    ref: "group",
    staticClass: "input-group",
    attrs: {
      "connection": _vm.currentIndex * 2 + 1,
      "hint": ""
    },
    model: {
      value: _vm.connections,
      callback: function ($$v) {
        _vm.connections = $$v;
      },
      expression: "connections"
    }
  }) : _c('UnitInputGroup3P', {
    ref: "group",
    staticClass: "input-group",
    attrs: {
      "connection": _vm.currentIndex + 1,
      "hint": ""
    },
    on: {
      "entry-meta-change": _vm.onConnectionEntryMetaChanged
    },
    model: {
      value: _vm.connections,
      callback: function ($$v) {
        _vm.connections = $$v;
      },
      expression: "connections"
    }
  }), _c('a-row', {
    staticClass: "back-n-next",
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('back-button', {
    style: {
      marginTop: 0
    }
  })], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('yellow-button', {
    attrs: {
      "data-tn": "phase-type-three-next",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.nextClicked
    }
  }, [_vm._v(" NEXT ")])], 1)], 1), _c('yellow-modal', {
    attrs: {
      "icon": "",
      "padding": "62px 26px 21px 26px"
    },
    model: {
      value: _vm.noteVisible,
      callback: function ($$v) {
        _vm.noteVisible = $$v;
      },
      expression: "noteVisible"
    }
  }, [_c('div', {
    style: {
      fontSize: '21px',
      marginBottom: '1em'
    }
  }, [_vm._v(" Enter the connected unit details eg:"), _c('br'), _vm._v(" - Apt 1"), _c('br'), _vm._v(" - Unit B"), _c('br'), _vm._v(" - Common light & power"), _c('br'), _vm._v(" Or, untick 'Connected' box if there is no connection here. ")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }